function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateOrangWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.41,
    height: 27.41,
    viewBox: "0 0 27.41 27.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 13.7,
    r: 13.7,
    style: {
      fill: "orange",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.69,19.21L14.17,4.49l.07-.12-.21-.12h0s0,0,0,0l-.21-.12-9,15.55h18v-.47h-.14ZM13.89,7.69l5.75,9.92h-11.49l5.74-9.92Zm.14-.24h0s0,0,0,0h0Zm-6.02,10.39h0,0s0,0,0,0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateOrangWarning);
export default __webpack_public_path__ + "static/media/state-orang-warning.77bb18f7a7060a990fdb020670622089.svg";
export { ForwardRef as ReactComponent };